var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:[ 'avatar', (_vm.small && 'is-small') ]},[_c('div',{staticClass:"avatar-inner"})])}
var staticRenderFns = []

export { render, staticRenderFns }